import * as React from 'react';
import { Button, LinkButton, UIHeading2, UIText1, UIText2 } from '@cian/ui-kit';
import * as styles from './PaymentResult.css';
import { useResponsive } from '../../../../hooks/useResponsive';
import { clsx } from 'clsx';
import { useApplicationContext } from '../../../../utils/applicationContext';
import { getButtonSize, getButtonTheme } from './utils';

interface IProps {
  title: string;
  description: string;
  buttonTitle: string;
  image: string;
  isLoading?: boolean;
  newOfferButton?: boolean;
  testId?: string;
  onClick(): void;
}

export const PaymentResult = (props: IProps) => {
  const { isMobile } = useResponsive();
  const { config } = useApplicationContext();

  const newOfferUrl = config.get<string>('payPackageMicrofrontend.addFormPath')!;

  const { title, description, buttonTitle, image, isLoading, newOfferButton, testId, onClick } = props;

  const Description = isMobile ? UIText1 : UIText2;

  const buttonSize = getButtonSize({ isSingleButton: !newOfferButton, isMobile });
  const buttonTheme = getButtonTheme({ isSingleButton: !newOfferButton });

  return (
    <div className={clsx(styles['content'], isMobile && styles['content_mobile'])} data-testid={testId}>
      <img src={image} width={64} height={64} alt="" className={styles['image']} />

      <UIHeading2 data-testid="payment-result-content-title">{title}</UIHeading2>

      <div className={styles['text']}>
        <Description>{description}</Description>
      </div>

      <div className={styles['buttons']}>
        {newOfferButton && (
          <LinkButton href={newOfferUrl} size="XS" theme="fill_primary" fullWidth data-name="success-redirect-button">
            Разместить объявление
          </LinkButton>
        )}

        <Button
          size={buttonSize}
          theme={buttonTheme}
          loading={isLoading}
          fullWidth={isMobile || newOfferButton}
          onClick={onClick}
        >
          {buttonTitle}
        </Button>
      </div>
    </div>
  );
};
